// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"791":"2faa49d4","1081":"ef0d9f49","1369":"ef0d9f49","2563":"091244ef","4516":"2faa49d4","5709":"2faa49d4","7454":"2faa49d4","7963":"94af158d"}[chunkId] + ".chunk.css";
};